import React from "react";
import "./header.css";
import "./footer.css";
function footer() {
  return (
    <footer className="main-footer">

              
        {/* <div>
          <h2 className="text-2xl font-bold mb-4">MiSitio</h2>
          <p className="text-gray-400 text-sm">
            Tu fuente confiable para todo lo relacionado con tecnología y diseño web.
          </p>
        </div> */}
          {/* Derechos reservados */}
      <div className="mt-10 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} BITDRAGEX all rights reserved.
      </div>

   

    <div className="footer-social">
       
        <a href="https://x.com/bitdragex" target="_blank" rel="noopener noreferrer">
          <img src="/images/x5.png" alt="Twitter" className="footer-icon" />
          
        </a>
        {/* Descomentado Telegram */}
        {/*
        <a href="https://web.telegram.org/k/#-2847775981" target="_blank" rel="noopener noreferrer">
          <img src="/images/telegram3.png" alt="Telegram" className="footer-icon" />
        </a>
        */}
        {/* Descomentado Discord */}
        <a href="https://discord.com/invite/3GNerp7N" target="_blank" rel="noopener noreferrer">
          <img src="/images/discord.png" alt="Discord" className="footer-icon" />
        </a>
        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=bitdragex@gmail.com&su=Hello&body=" target="_blank" rel="noopener noreferrer">
          <img src="/images/gmail.png" alt="gmail" className="footer-icon" />
        </a>
      </div>

   
    </footer>
  );
}

export default footer;